/* unplugin-vue-components disabled */import { render } from "./bindUser.vue?vue&type=template&id=635a1b44&scoped=true"
import script from "./bindUser.vue?vue&type=script&lang=js"
export * from "./bindUser.vue?vue&type=script&lang=js"

import "./bindUser.vue?vue&type=style&index=0&id=635a1b44&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635a1b44"]])

export default __exports__